import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { URLS } from '@wix/da-url';
import s from './BitPayAccountBlock.scss';

export interface Props {
  bitpayEmail?: string;
  className?: string;
}

const BitPayAccountBlock: FC<Props> = ({ bitpayEmail = 'example@gmail.com', className }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={s['account-info']}>
        <span className={s['account-label']}>
          {t('studio.earnings.bitpay.withdraw.modal.account.label')}
        </span>
        <span className={s['account-email']}>{bitpayEmail}</span>
      </div>

      <div className={s['change-account']}>
        {t('studio.earnings.bitpay.withdraw.modal.account.changeNote.prefix')}{' '}
        <a href={URLS.SUPPORT} className="text-link-level-2-secondary">
          {t('studio.earnings.bitpay.withdraw.modal.account.changeNote.contactSupport')}
        </a>
        .
      </div>
    </div>
  );
};

BitPayAccountBlock.displayName = 'BitPayAccountBlock';

export default BitPayAccountBlock;
